// extracted by mini-css-extract-plugin
export var select = "_ps-0";